import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const AILanguage = {
  Dutch: 'nl',
  English: 'en',
  Auto: 'auto',
} as const;

export type AILanguage = (typeof AILanguage)[keyof typeof AILanguage];

type ReachoutMessageGenerationStore = {
  aiLanguage: AILanguage;
  setAiLanguage: (aiLanguage: AILanguage) => void;
};

export const useReachoutMessageGenerationStore = create<ReachoutMessageGenerationStore>()(
  persist(
    (set) => ({
      aiLanguage: AILanguage.Auto,
      setAiLanguage: (aiLanguage) => set({ aiLanguage }),
    }),
    { name: 'reachout-message-generation' },
  ),
);

export const useReachoutMessageGenerationLanguage = () => {
  return useReachoutMessageGenerationStore((state) => state.aiLanguage);
};

export const useReachoutMessageGenerationSetLanguage = () => {
  return useReachoutMessageGenerationStore((state) => state.setAiLanguage);
};
